var map = {
	"./alertHexIcon.svg": 57847,
	"./back.svg": 43592,
	"./callAnAmbulanceIcon.svg": 87601,
	"./checkIcon.svg": 61164,
	"./chevronDown.svg": 78790,
	"./chevronUp.svg": 14141,
	"./close.svg": 54543,
	"./consultADoctorIcon.svg": 20794,
	"./copyIcon.svg": 69657,
	"./copyIcon2.svg": 83785,
	"./editIcon2.svg": 41200,
	"./editSettingsIcon.svg": 30729,
	"./femaleIconGeneric.svg": 28317,
	"./guidelineIcon.svg": 39786,
	"./inProgressIcon.svg": 50570,
	"./kahunLogo.svg": 84367,
	"./kahunLogoNew.svg": 11099,
	"./knowlengeIcon.svg": 61758,
	"./landingPageDotsBackground.svg": 77779,
	"./maleIconGeneric.svg": 3800,
	"./openInNewIcon.svg": 17369,
	"./patientCard/chartViewIcon.svg": 49155,
	"./patientCard/checkCircleIcon.svg": 63708,
	"./patientCard/kahunLogo.svg": 32915,
	"./patientCard/patient1stLogoWhite.svg": 10904,
	"./patientCard/summaryViewIcon.svg": 94771,
	"./patientCard/validatedIcon.svg": 25662,
	"./patientCard/viewOnAgentIcon.svg": 1783,
	"./patientCard/xCircleIcon.svg": 17496,
	"./ratingStar.svg": 74842,
	"./selfTreatmentIcon.svg": 77666,
	"./successIcon.svg": 64525,
	"./thumbsDownIcon.svg": 2517,
	"./thumbsUpIcon.svg": 19482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40569;